//  ----------      START   IMPORT  BLOCK       ----------
import { Row, Col, Form, Card } from "react-bootstrap";
import { TelephoneFill, Building, Map } from "react-bootstrap-icons";
import SpecialtySubPicker from "./Widgets/SpecialtySubPicker";
import { useLanguage } from "../../../../../API/Context/LanguageContext";
import { VocabProOnboarding as Vocab } from "../../../../../ConfigFiles/multilingual/VocabProOnboarding";
import StateService from "../../../../../API/Services/Geography/StateService";
import PhoneWidget from "../../../Generic/PhoneWidget";
//  ----------      END   IMPORT  BLOCK       ----------

const StepWorkLocation = ({ data, update, metadata, updateMeta }) => {
    const { lan } = useLanguage();
    const statesService = new StateService();

    const updateWorkLocation = (field, value) => {
        update({
            professional_work_location: {
                ...data.professional_work_location,
                [field]: value
            }
        });
    };

    const updateAssignment = (field, value) => {
        const numericValue = value === "" ? 0 : parseInt(value);
        update({
            professional_assignment: {
                ...data.professional_assignment,
                [field]: numericValue 
            }
        });
    };

    return (
        <div className="animate-in">
            <h4 className="mb-4 border-start border-primary border-4 ps-3">
                <Building className="me-2 text-primary" />
                {Vocab.location_section_title[lan]}
            </h4>

            <Card className="border-0 shadow-sm bg-light mb-4">
                <Card.Body>
                    <Row className="g-3">
                        {/* 1. Name of the Clinic/Office */}
                        <Col md={12}>
                            <Form.Label className="small fw-bold">{Vocab.work_name[lan]}</Form.Label>
                            <Form.Control 
                                placeholder={Vocab.work_name_placeholder[lan]}
                                value={data.professional_work_location.location_name}
                                onChange={(e) => updateWorkLocation("location_name", e.target.value)}
                            />
                        </Col>

                        {/* 2. Street and Numbers */}
                        <Col md={6}>
                            <Form.Label className="small fw-bold">{Vocab.street[lan]}</Form.Label>
                            <Form.Control 
                                value={data.professional_work_location.street}
                                onChange={(e) => updateWorkLocation("street", e.target.value)}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Label className="small fw-bold">{Vocab.external_number[lan]}</Form.Label>
                            <Form.Control 
                                type="number"
                                value={data.professional_work_location.number}
                                onChange={(e) => updateWorkLocation("number", e.target.value)}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Label className="small fw-bold">{Vocab.interior_number[lan]}</Form.Label>
                            <Form.Control 
                                type="number"
                                value={data.professional_assignment.interior_number}
                                onChange={(e) => updateAssignment("interior_number", e.target.value)}
                            />
                        </Col>

                        {/* 3. State & City */}
                        <Col md={6}>
                            <Form.Label className="small fw-bold">
                                <Map className="me-1" size={12}/> {Vocab.state[lan]}
                            </Form.Label>
                            <SpecialtySubPicker 
                                searchFunction={(q, l, s) => statesService.searchState(q, l, s)}
                                selectedValue={data.professional_work_location.state_id}
                                selectedLabel={metadata.states?.[data.professional_work_location.state_id]?.name}
                                placeholder={Vocab.state_placeholder?.[lan] || "Search State..."}
                                onSelect={(state, isClear) => {
                                    if (isClear || !state) {
                                        updateWorkLocation("state_id", null);
                                        return;
                                    }
                                    updateMeta("states", { [state.id]: { name: state.name } });
                                    updateWorkLocation("state_id", state.id);
                                }}
                            />
                        </Col>

                        {/* 4. Zip and Phone Widget Integration */}
                        <Col md={6}>
                            <Form.Label className="small fw-bold">{Vocab.zip_code[lan]}</Form.Label>
                            <Form.Control 
                                maxLength={5}
                                value={data.professional_work_location.zip_code}
                                onChange={(e) => updateWorkLocation("zip_code", e.target.value.replace(/\D/g, ''))}
                            />
                        </Col>

                        <Col md={5} className="position-relative">
                            <Form.Label className="small fw-bold">
                                <TelephoneFill className="me-1" size={12}/> {Vocab.phone_number[lan]}
                            </Form.Label>
                            {/* 🎯 Swapped Form.Control for PhoneWidget */}
                            <PhoneWidget 
                                value={data.professional_work_location.main_phone}
                                onChange={(val) => updateWorkLocation("main_phone", val)}
                            />
                        </Col>
                        
                        <Col md={3}>
                            <Form.Label className="small fw-bold">{Vocab.extension[lan]}</Form.Label>
                            <Form.Control 
                                value={data.professional_assignment.work_extension}
                                onChange={(e) => updateAssignment("work_extension", e.target.value)}
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
};

export default StepWorkLocation;
